document.addEventListener("DOMContentLoaded", function () {
  let filterColors = [];
  let filterSizes = [];
  let filterproducttypes = [];
  let filterLidTypes = [];
  let baseColorCounts = new Map();
  let baseSizeCounts = new Map();
  let baseProductTypeCounts = new Map();
  let baseLidTypeCounts = new Map();
  let refreshTimer = null;
  let isMobilePreviewMode = false;
  let isSyncing = false;

  // Read cf_ params from URL on reload
  const params = new URLSearchParams(window.location.search);
  const colorParam = params.get("cf_color");
  const sizeParam = params.get("cf_size");
  const typeParam = params.get("cf_type");
  const lidParam = params.get("cf_lid");
  if (colorParam)
    filterColors = colorParam
      .split(",")
      .map((c) => c.trim().toLowerCase())
      .filter(Boolean);
  if (sizeParam)
    filterSizes = sizeParam
      .split(",")
      .map((v) => normalizeSizeFilterValue(v))
      .filter(Boolean);
  if (typeParam)
    filterproducttypes = typeParam
      .split(",")
      .map((v) => v.trim().toLowerCase())
      .filter(Boolean);
  if (lidParam)
    filterLidTypes = lidParam
      .split(",")
      .map((v) => v.trim().toLowerCase())
      .filter(Boolean);

  function syncCheckboxesFromURL() {
    document
      .querySelectorAll('#filter-color input[type="checkbox"]')
      .forEach((cb) => {
        const val = cb.value.toLowerCase();
        if (filterColors.includes(val)) cb.checked = true;
      });

    document
      .querySelectorAll('#filter-size input[type="checkbox"]')
      .forEach((cb) => {
        const val = getSizeValue(cb);
        if (filterSizes.includes(val)) cb.checked = true;
      });

    document
      .querySelectorAll('#filter-producttype input[type="checkbox"]')
      .forEach((cb) => {
        const val = (cb.dataset.optionProducttype || cb.value).toLowerCase();
        if (filterproducttypes.includes(val)) cb.checked = true;
      });

    document
      .querySelectorAll('#filter-lidtype input[type="checkbox"]')
      .forEach((cb) => {
        const val = (cb.dataset.optionLidtype || cb.value).toLowerCase();
        if (filterLidTypes.includes(val)) cb.checked = true;
      });
  }

  function getDeviceType(e) {
    const userAgent = navigator.userAgent.toLowerCase();
    const isMobile =
      /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(
        userAgent,
      );
    const hasTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth < 768;

    if (isMobile || (hasTouch && isSmallScreen)) {
      return "Mobile";
    } else if (hasTouch) {
      return "Tablet";
    } else {
      return "Desktop/Laptop";
    }
  }

  function getAllCards() {
    const containerId = "product_content";
    const container = document.getElementById(containerId);
    if (!container) return [];
    return Array.from(container.querySelectorAll(".product-card"));
  }

  function isCardVisible(card) {
    return !!(card && card.offsetParent !== null);
  }

  function normalizeFilterValue(value) {
    return (value || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]/g, "");
  }

  function normalizeSizeFilterValue(value) {
    const normalizedValue = (value || "").toString().trim().toLowerCase();
    if (!normalizedValue) return "";
    if (
      normalizedValue === "others" ||
      normalizedValue.includes("oz") ||
      normalizedValue.includes("qt")
    ) {
      return normalizedValue;
    }
    return "others";
  }

  function valuesLooselyMatch(firstValue, secondValue) {
    const normalizedFirst = normalizeFilterValue(firstValue);
    const normalizedSecond = normalizeFilterValue(secondValue);
    if (!normalizedFirst || !normalizedSecond) return false;
    return (
      normalizedFirst === normalizedSecond ||
      normalizedFirst.includes(normalizedSecond) ||
      normalizedSecond.includes(normalizedFirst)
    );
  }

  function sizeValuesMatch(firstValue, secondValue) {
    return valuesLooselyMatch(
      normalizeSizeFilterValue(firstValue),
      normalizeSizeFilterValue(secondValue),
    );
  }

  function isSwatchAvailableForSizeInput(swatchInput, sizeInput) {
    if (!swatchInput || !sizeInput) return false;

    const sizeKey = normalizeFilterValue(sizeInput.value);
    const availableSizes = (
      (swatchInput.dataset && swatchInput.dataset.availableSizes) ||
      ""
    )
      .split("|")
      .map((sizeValue) => normalizeFilterValue(sizeValue))
      .filter(Boolean);

    if (availableSizes.length) {
      return availableSizes.includes(sizeKey);
    }

    const fallbackColors = (
      (sizeInput.dataset && sizeInput.dataset.colorSizewise) ||
      ""
    )
      .split(",")
      .map((colorValue) => normalizeFilterValue(colorValue))
      .filter(Boolean);

    return fallbackColors.includes(normalizeFilterValue(swatchInput.value));
  }

  function cardHasMatchingSizeColor(card, activeSizes, activeColors) {
    if (!card || !activeSizes.length || !activeColors.length) return true;

    const sizeInputs = [
      ...card.querySelectorAll(".product-card__sizes input.size-click"),
    ];
    const swatchContainer = card.querySelector(".product-swatches");
    const swatchInputs = swatchContainer
      ? [...swatchContainer.querySelectorAll("input.color-click")]
      : [];

    if (!sizeInputs.length || !swatchInputs.length || !swatchContainer) {
      return true;
    }

    return sizeInputs.some((sizeInput) => {
      const sizeMatches = activeSizes.some((activeSize) =>
        sizeValuesMatch(sizeInput.value, activeSize),
      );
      if (!sizeMatches) return false;

      return swatchInputs.some((swatchInput) => {
        if (!isSwatchAvailableForSizeInput(swatchInput, sizeInput)) return false;

        const label = swatchContainer.querySelector(
          `label[for="${swatchInput.id}"]`,
        );
        const swatchName =
          (label &&
            label.dataset &&
            (label.dataset.swatchName || label.dataset.optionName)) ||
          swatchInput.value;
        const baseColors = (swatchInput.dataset.baseColor || "")
          .split(",")
          .map((colorValue) => normalizeFilterValue(colorValue))
          .filter(Boolean);

        return activeColors.some((activeColor) => {
          const normalizedActiveColor = normalizeFilterValue(activeColor);
          return (
            valuesLooselyMatch(swatchName, normalizedActiveColor) ||
            baseColors.some((baseColor) =>
              valuesLooselyMatch(baseColor, normalizedActiveColor),
            )
          );
        });
      });
    });
  }

  function cardMatchesActiveFilters(card, options = {}) {
    const {
      ignoreColor = false,
      ignoreSize = false,
      ignoreProductType = false,
      ignoreLidType = false,
    } = options;
    const activeColors = ignoreColor ? [] : filterColors;
    const activeSizes = ignoreSize ? [] : filterSizes;
    const activeProductTypes = ignoreProductType ? [] : filterproducttypes;
    const activeLidTypes = ignoreLidType ? [] : filterLidTypes;
    const cardSizes = (card.dataset.variantSize || "")
      .split(",")
      .map((sizeValue) => normalizeSizeFilterValue(sizeValue))
      .filter(Boolean);
    const cardColors = (card.dataset.variantColor || "")
      .split(",")
      .map((colorValue) => colorValue.trim())
      .filter(Boolean);
    const cardProductTypes = (card.dataset.variantProducttype || "")
      .split(",")
      .map((productTypeValue) => productTypeValue.trim())
      .filter(Boolean);
    const cardLidTypes = (card.dataset.variantLidtype || "")
      .split(",")
      .map((lidTypeValue) => lidTypeValue.trim())
      .filter(Boolean);

    const matchColor =
      activeColors.length === 0 ||
      activeColors.some((activeColor) =>
        cardColors.some((cardColor) =>
          valuesLooselyMatch(cardColor, activeColor),
        ),
      );

    const matchSize =
      activeSizes.length === 0 ||
      activeSizes.some((activeSize) =>
        cardSizes.some((cardSize) => sizeValuesMatch(cardSize, activeSize)),
      );

    const matchProductType =
      activeProductTypes.length === 0 ||
      activeProductTypes.some((activeProductType) =>
        cardProductTypes.some((cardProductType) =>
          valuesLooselyMatch(cardProductType, activeProductType),
        ),
      );

    const matchLidType =
      activeLidTypes.length === 0 ||
      activeLidTypes.some((activeLidType) =>
        cardLidTypes.some((cardLidType) =>
          valuesLooselyMatch(cardLidType, activeLidType),
        ),
      );

    const matchSizeColorCombo = cardHasMatchingSizeColor(
      card,
      activeSizes,
      activeColors,
    );

    return (
      matchColor &&
      matchSize &&
      matchProductType &&
      matchLidType &&
      matchSizeColorCombo
    );
  }

  function getCountForValue(countMap, value) {
    if (!countMap || !countMap.size) return 0;
    if (countMap.has(value)) return countMap.get(value) || 0;

    let matchedCount = 0;
    for (const [key, count] of countMap.entries()) {
      if (valuesLooselyMatch(key, value)) {
        matchedCount += count || 0;
      }
    }
    return matchedCount;
  }

  function isValueInActiveFilters(value) {
    return (
      filterColors.some((activeValue) => valuesLooselyMatch(activeValue, value)) ||
      filterSizes.some((activeValue) => sizeValuesMatch(activeValue, value)) ||
      filterproducttypes.some((activeValue) =>
        valuesLooselyMatch(activeValue, value),
      ) ||
      filterLidTypes.some((activeValue) => valuesLooselyMatch(activeValue, value))
    );
  }

  function incrementCount(countMap, value) {
    const normalizedValue = (value || "").toString().trim().toLowerCase();
    if (!normalizedValue) return;
    countMap.set(normalizedValue, (countMap.get(normalizedValue) || 0) + 1);
  }

  function recomputeColorCounts(cards) {
    const colorCounts = new Map();

    cards.forEach((card) => {
      const swatchContainer = card.querySelector(".product-swatches");
      const swatchInputs = swatchContainer
        ? [...swatchContainer.querySelectorAll("input.color-click")]
        : [];
      const sizeInputs = [
        ...card.querySelectorAll(".product-card__sizes input.size-click"),
      ];

      if (!swatchInputs.length) {
        (card.dataset.variantColor || "")
          .split(",")
          .map((colorValue) => colorValue.trim())
          .filter(Boolean)
          .forEach((colorValue) => incrementCount(colorCounts, colorValue));
        return;
      }

      let relevantSizes = sizeInputs;
      if (filterSizes.length > 0 && sizeInputs.length > 0) {
        relevantSizes = sizeInputs.filter((sizeInput) =>
          filterSizes.some((activeSize) =>
            sizeValuesMatch(sizeInput.value, activeSize),
          ),
        );
      }

      swatchInputs.forEach((swatchInput) => {
        const isAvailableForRelevantSize =
          !relevantSizes.length ||
          relevantSizes.some((sizeInput) =>
            isSwatchAvailableForSizeInput(swatchInput, sizeInput),
          );

        if (!isAvailableForRelevantSize) return;

        const baseColors = (swatchInput.dataset.baseColor || "")
          .split(",")
          .map((colorValue) => colorValue.trim())
          .filter(Boolean);

        if (baseColors.length > 0) {
          baseColors.forEach((colorValue) =>
            incrementCount(colorCounts, colorValue),
          );
          return;
        }

        const label = swatchContainer.querySelector(`label[for="${swatchInput.id}"]`);
        incrementCount(
          colorCounts,
          (label &&
            label.dataset &&
            (label.dataset.optionName || label.dataset.swatchName)) ||
            swatchInput.value,
        );
      });
    });

    return colorCounts;
  }

  function recomputeSizeCounts(cards) {
    const sizeCounts = new Map();

    cards.forEach((card) => {
      const sizeInputs = [
        ...card.querySelectorAll(".product-card__sizes input.size-click"),
      ];
      const swatchContainer = card.querySelector(".product-swatches");
      const swatchInputs = swatchContainer
        ? [...swatchContainer.querySelectorAll("input.color-click")]
        : [];

      if (!sizeInputs.length) {
        (card.dataset.variantSize || "")
          .split(",")
          .map((sizeValue) => normalizeSizeFilterValue(sizeValue))
          .filter(Boolean)
          .forEach((sizeValue) => incrementCount(sizeCounts, sizeValue));
        return;
      }

      sizeInputs.forEach((sizeInput) => {
        if (!filterColors.length || !swatchInputs.length) {
          incrementCount(sizeCounts, normalizeSizeFilterValue(sizeInput.value));
          return;
        }

        const hasMatchingColor = swatchInputs.some((swatchInput) => {
          if (!isSwatchAvailableForSizeInput(swatchInput, sizeInput)) return false;

          const label = swatchContainer.querySelector(`label[for="${swatchInput.id}"]`);
          const swatchName =
            (label &&
              label.dataset &&
              (label.dataset.swatchName || label.dataset.optionName)) ||
            swatchInput.value;
          const baseColors = (swatchInput.dataset.baseColor || "")
            .split(",")
            .map((colorValue) => colorValue.trim())
            .filter(Boolean);

          return filterColors.some((activeColor) => {
            return (
              valuesLooselyMatch(swatchName, activeColor) ||
              baseColors.some((baseColor) =>
                valuesLooselyMatch(baseColor, activeColor),
              )
            );
          });
        });

        if (hasMatchingColor) {
          incrementCount(sizeCounts, normalizeSizeFilterValue(sizeInput.value));
        }
      });
    });

    return sizeCounts;
  }

  function recomputeProductTypeCounts(cards) {
    const productTypeCounts = new Map();

    cards.forEach((card) => {
      (card.dataset.variantProducttype || "")
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean)
        .forEach((value) => incrementCount(productTypeCounts, value));
    });

    return productTypeCounts;
  }

  function recomputeLidTypeCounts(cards) {
    const lidTypeCounts = new Map();

    cards.forEach((card) => {
      (card.dataset.variantLidtype || "")
        .split(",")
        .map((value) => value.trim())
        .filter(Boolean)
        .forEach((value) => incrementCount(lidTypeCounts, value));
    });

    return lidTypeCounts;
  }

  function recomputeCountsForCurrentFilters() {
    const cardsForColors = allCards.filter((card) =>
      cardMatchesActiveFilters(card, { ignoreColor: true }),
    );
    const cardsForSizes = allCards.filter((card) =>
      cardMatchesActiveFilters(card, { ignoreSize: true }),
    );
    const cardsForProductTypes = allCards.filter((card) =>
      cardMatchesActiveFilters(card, { ignoreProductType: true }),
    );
    const cardsForLidTypes = allCards.filter((card) =>
      cardMatchesActiveFilters(card, { ignoreLidType: true }),
    );

    return {
      colorCounts: recomputeColorCounts(cardsForColors),
      sizeCounts: recomputeSizeCounts(cardsForSizes),
      productTypeCounts: recomputeProductTypeCounts(cardsForProductTypes),
      lidTypeCounts: recomputeLidTypeCounts(cardsForLidTypes),
    };
  }

  function applyCurrentFilterCounts() {
    const { colorCounts, sizeCounts, productTypeCounts, lidTypeCounts } =
      recomputeCountsForCurrentFilters();

    applyCountsOnly(colorCheckboxes, colorCounts, getColorValue);
    applyCountsOnly(sizeCheckboxes, sizeCounts, getSizeValue);
    applyCountsOnly(
      productTypeCheckboxes,
      productTypeCounts,
      getProductTypeValue,
    );
    applyCountsOnly(lidTypeCheckboxes, lidTypeCounts, getLidTypeValue);
  }

  // Sync a card's selected size and visible swatches to active filter state.
  function syncCardSwatchesAndSize(card) {
    const swatchContainer = card.querySelector(".product-swatches");
    const sizeContainer = card.querySelector(".product-card__sizes");
    const normalize = (value) =>
      (value || "")
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]/g, "");
    const colorMatchesAnyFilter = (colorValue) => {
      const normalizedColor = normalize(colorValue);
      if (!normalizedColor || normalizedFilterColors.length === 0) return false;
      return normalizedFilterColors.some(
        (filterColor) =>
          normalizedColor === filterColor ||
          normalizedColor.includes(filterColor) ||
          filterColor.includes(normalizedColor),
      );
    };
    const normalizedFilterColors = (filterColors || []).map((c) => normalize(c));

    let targetSizeInput = null;
    const isSwatchAvailableForSize = (swatchInput, sizeInput) => {
      if (!swatchInput || !sizeInput) return false;
      const sizeKey = normalize(sizeInput.value);
      const availableSizes = ((swatchInput.dataset && swatchInput.dataset.availableSizes) || "")
        .split("|")
        .map((s) => normalize(s))
        .filter(Boolean);
      if (availableSizes.length) {
        return availableSizes.includes(sizeKey);
      }
      const fallbackColors = ((sizeInput.dataset && sizeInput.dataset.colorSizewise) || "")
        .split(",")
        .map((c) => normalize(c))
        .filter(Boolean);
      return fallbackColors.includes(normalize(swatchInput.value));
    };
    if (sizeContainer) {
      const sizeInputs = [...sizeContainer.querySelectorAll("input.size-click")];

      if (filterSizes.length > 0) {
        targetSizeInput = sizeInputs.find((input) =>
          filterSizes.some((fs) => sizeValuesMatch(input.value, fs)),
        );
      }

      if (!targetSizeInput) {
        const defaultSize = normalize(card.dataset.defaultSize);
        targetSizeInput =
          sizeInputs.find((input) => normalize(input.value) === defaultSize) ||
          sizeContainer.querySelector("input.size-click:checked") ||
          sizeInputs[0];
      }

      // If a color filter is active and selected size cannot serve that color,
      // switch to the first size that has a matching color.
      if (
        normalizedFilterColors.length > 0 &&
        swatchContainer &&
        filterSizes.length === 0
      ) {
        const swatchInputs = [...swatchContainer.querySelectorAll("input.color-click")];
        const hasMatchingColorForSize = (sizeInput) => {
          if (!sizeInput) return false;

          return swatchInputs.some((swatchInput) => {
            const label = swatchContainer.querySelector(`label[for="${swatchInput.id}"]`);
            if (!isSwatchAvailableForSize(swatchInput, sizeInput)) return false;
            const baseColors = (swatchInput.dataset.baseColor || "")
              .split(",")
              .map((c) => normalize(c))
              .filter(Boolean);
            const swatchName = normalize(
              (label && label.dataset && (label.dataset.swatchName || label.dataset.optionName)) ||
                swatchInput.value,
            );
            return (
              colorMatchesAnyFilter(swatchName) ||
              baseColors.some((c) => colorMatchesAnyFilter(c))
            );
          });
        };

        if (!hasMatchingColorForSize(targetSizeInput)) {
          const fallbackSize = sizeInputs.find((input) =>
            hasMatchingColorForSize(input),
          );
          if (fallbackSize) {
            targetSizeInput = fallbackSize;
          }
        }
      }

      if (targetSizeInput) {
        const activeSizeInput =
          sizeContainer && sizeContainer.querySelector("input.size-click:checked");
        const sizeChanged = activeSizeInput !== targetSizeInput;

        sizeInputs.forEach((input) => {
          input.checked = false;
        });
        targetSizeInput.checked = true;
        targetSizeInput.dataset.button = "checked";
        if (sizeChanged) {
          targetSizeInput.dispatchEvent(new Event("click", { bubbles: true }));
        }

        const productName = card.querySelector(".product-name");
        const baseTitle =
          productName && productName.dataset
            ? (productName.dataset.baseTitle || "").trim()
            : "";
        if (productName && baseTitle && targetSizeInput.value) {
          const normalizedSize = targetSizeInput.value.toLowerCase();
          const sizePrefix =
            normalizedSize.includes("oz") || normalizedSize.includes("qt")
              ? `${targetSizeInput.value} `
              : "";
          productName.textContent = `${sizePrefix}${baseTitle}`.replace(/\s+/g, " ").trim();
        }
      }
    }

    if (typeof window.colorShade === "function") {
      window.colorShade();
    }

    setTimeout(() => {
      if (!swatchContainer) return;
      const swatchInputs = [...swatchContainer.querySelectorAll("input.color-click")];
      const activeSizeInput =
        targetSizeInput ||
        (sizeContainer && sizeContainer.querySelector("input.size-click:checked"));

      let allowedColors = [];
      if (activeSizeInput) {
        allowedColors = swatchInputs
          .filter((input) => isSwatchAvailableForSize(input, activeSizeInput))
          .map((input) => {
            const label = swatchContainer.querySelector(`label[for="${input.id}"]`);
            return normalize(
              (label && label.dataset && (label.dataset.swatchName || label.dataset.optionName)) ||
                input.value,
            );
          });
      }

      swatchInputs.forEach((input) => {
        const label = swatchContainer.querySelector(`label[for="${input.id}"]`);
        if (!label) return;
        const colorVal = normalize(
          (label.dataset && (label.dataset.swatchName || label.dataset.optionName)) ||
            input.value,
        );
        const show = activeSizeInput
          ? allowedColors.includes(colorVal)
          : true;
        label.classList.toggle("is-visible", show);
        if (!show) {
          label.classList.remove("first_four");
          label.classList.remove("not_first_four");
          label.style.setProperty("display", "none", "important");
        } else {
          label.style.removeProperty("display");
        }
      });

      const visibleLabels = swatchInputs
        .map((input) => swatchContainer.querySelector(`label[for="${input.id}"]`))
        .filter((label) => label && label.classList.contains("is-visible"));
      const isExpanded = swatchContainer.classList.contains("show-all-swatch");
      visibleLabels.forEach((label, index) => {
        label.classList.remove("first_four");
        label.classList.remove("not_first_four");
        if (index < 4) {
          label.classList.add("first_four");
          label.style.removeProperty("display");
        } else if (!isExpanded) {
          label.classList.add("not_first_four");
          label.style.setProperty("display", "none", "important");
        } else {
          label.style.removeProperty("display");
        }
      });

      const remainingWrap = card.querySelector(".product-swatches__remaining");
      if (remainingWrap) {
        const remainingCount = visibleLabels.length - 4;
        if (remainingCount > 0) {
          remainingWrap.style.display = "";
          const spans = remainingWrap.querySelectorAll("span");
          if (spans.length > 0) {
            spans[0].textContent = `+${remainingCount}`;
          }
          if (spans.length > 1 && remainingWrap.dataset.expandBound !== "true") {
            remainingWrap.dataset.expandBound = "true";
            spans[0].addEventListener("click", (event) => {
              const parentSwatches = event.currentTarget.closest(".product-swatches");
              if (!parentSwatches) return;
              parentSwatches.classList.add("show-all-swatch");
              syncCardSwatchesAndSize(card);
            });
            spans[1].addEventListener("click", (event) => {
              const parentSwatches = event.currentTarget.closest(".product-swatches");
              if (!parentSwatches) return;
              parentSwatches.classList.remove("show-all-swatch");
              syncCardSwatchesAndSize(card);
            });
          }
        } else {
          remainingWrap.style.display = "none";
          swatchContainer.classList.remove("show-all-swatch");
        }
      }

      const visibleSwatches = swatchInputs.filter((input) => {
        const label = swatchContainer.querySelector(`label[for="${input.id}"]`);
        return label && label.classList.contains("is-visible");
      });
      if (!visibleSwatches.length) return;

      if (filterColors.length === 0) {
        const firstVisibleLabel = swatchContainer.querySelector(
          `label[for="${visibleSwatches[0].id}"]`,
        );
        if (firstVisibleLabel) firstVisibleLabel.click();
        return;
      }

      const matched = visibleSwatches.find((input) => {
        const label = swatchContainer.querySelector(`label[for="${input.id}"]`);
        const swatchName = normalize(
          (label && label.dataset && (label.dataset.swatchName || label.dataset.optionName)) ||
            input.value,
        );
        const baseColors = (input.dataset.baseColor || "")
          .split(",")
          .map((c) => normalize(c))
          .filter(Boolean);
        return (
          colorMatchesAnyFilter(swatchName) ||
          baseColors.some((c) => colorMatchesAnyFilter(c))
        );
      });

      if (!matched && filterColors.length > 0) {
        card.dataset.filtered = "true";
        if (!isMobilePreviewMode) {
          card.style.display = "none";
        }
        return;
      }

      const targetLabel = swatchContainer.querySelector(
        `label[for="${(matched || visibleSwatches[0]).id}"]`,
      );
      if (targetLabel) targetLabel.click();
    }, 120);
  }

  let allCards = getAllCards();

  const colorCheckboxes = document.querySelectorAll(
    'input.color-click[type="checkbox"]',
  );
  const sizeCheckboxes = document.querySelectorAll(
    'input.size-click[type="checkbox"]',
  );
  const productTypeCheckboxes = document.querySelectorAll(
    'input.producttype-click[type="checkbox"]',
  );
  const lidTypeCheckboxes = document.querySelectorAll(
    'input.lidtype-click[type="checkbox"]',
  );
  function getColorValue(cb) {
    const label = document.querySelector(`label[for="${cb.id}"]`);
    const fromLabel =
      label?.dataset?.swatchName ||
      label?.dataset?.optionName ||
      label?.dataset?.swatchColor;
    return (fromLabel || cb.value || "").trim().toLowerCase();
  }

  function getSizeValue(cb) {
    return normalizeSizeFilterValue(cb.dataset.optionSize || cb.value || "");
  }
  function getProductTypeValue(pt) {
    return (pt.dataset.optionProducttype || pt.value || "")
      .trim()
      .toLowerCase();
  }
  function getLidTypeValue(cb) {
    return (cb.dataset.optionLidtype || cb.value || "").trim().toLowerCase();
  }
  function applyCountsOnly(checkboxes, countMap, getValue) {
    checkboxes.forEach((cb) => {
      const value = getValue(cb);
      const count = getCountForValue(countMap, value);
      if (count === 0) {
        cb.disabled = true;
        // only uncheck if not an active filter
        const isActiveFilter = isValueInActiveFilters(value);
        if (!isActiveFilter) cb.checked = false;
      } else {
        cb.disabled = false;
      }

      const label = document.querySelector(`label[for="${cb.id}"]`);
      if (!label) return;

      const span = label.querySelector("span.variant-with-number");
      if (!span) return;

      span.innerText = span.innerText.split(" (")[0] + ` (${count})`;
    });
  }
  //  IMPROVED REFRESH COUNTS

  function refreshCounts(cardsParam) {
    const cards = cardsParam || allCards;
    if (!cards.length) return;
    baseColorCounts = new Map();
    baseSizeCounts = new Map();
    baseProductTypeCounts = new Map();
    baseLidTypeCounts = new Map();

    for (const card of cards) {
      const colors = (card.dataset.variantColor || "")
        .split(",")
        .map((c) => c.trim().toLowerCase())
        .filter(Boolean);

      const sizes = (card.dataset.variantSize || "")
        .split(",")
        .map((s) => normalizeSizeFilterValue(s))
        .filter(Boolean);
      const productType = (card.dataset.variantProducttype || "")
        .split(",")
        .map((pt) => pt.trim().toLowerCase())
        .filter(Boolean);
      const lidType = (card.dataset.variantLidtype || "")
        .split(",")
        .map((l) => l.trim().toLowerCase())
        .filter(Boolean);

      for (const c of colors) {
        baseColorCounts.set(c, (baseColorCounts.get(c) || 0) + 1);
      }

      for (const s of sizes) {
        baseSizeCounts.set(s, (baseSizeCounts.get(s) || 0) + 1);
      }
      for (const pt of productType) {
        baseProductTypeCounts.set(pt, (baseProductTypeCounts.get(pt) || 0) + 1);
      }
      for (const l of lidType) {
        baseLidTypeCounts.set(l, (baseLidTypeCounts.get(l) || 0) + 1);
      }
    }

    applyCountsOnly(colorCheckboxes, baseColorCounts, getColorValue);
    applyCountsOnly(sizeCheckboxes, baseSizeCounts, getSizeValue);
    applyCountsOnly(
      productTypeCheckboxes,
      baseProductTypeCounts,
      getProductTypeValue,
    );
    applyCountsOnly(lidTypeCheckboxes, baseLidTypeCounts, getLidTypeValue);
  }

  // Run once on load
  refreshCounts();
  setTimeout(() => {
    allCards = getAllCards();
    allCards.forEach((card) => {
      if (card.dataset.filtered === "true") return;
      syncCardSwatchesAndSize(card);
    });
  }, 120);

  if (
    !filterColors.length &&
    !filterSizes.length &&
    !filterproducttypes.length &&
    !filterLidTypes.length
  ) {
    syncCheckboxesFromURL();
  }

  // On reload with URL filters, wait for cards then apply
  if (
    filterColors.length ||
    filterSizes.length ||
    filterproducttypes.length ||
    filterLidTypes.length
  ) {
    function tryApplyInitialFilters(attempts) {
      const cards = getAllCards();
      if (cards.length > 0) {
        allCards = cards;

        // Refresh counts with real cards so active checkboxes aren't disabled
        refreshCounts(allCards);

        allCards.forEach((card) => {
          const matchesFilters = cardMatchesActiveFilters(card);

          card.dataset.filtered = matchesFilters ? "false" : "true";
          card.style.display = matchesFilters ? "" : "none";
        });

        // Update results count
        const visibleCount = allCards.filter(
          (c) => c.dataset.filtered === "false",
        ).length;
        const resultsEl = document.querySelector(
          "#collection__filter__results",
        );
        if (resultsEl)
          resultsEl.innerText =
            visibleCount + (visibleCount === 1 ? " result" : " results");

        applyCurrentFilterCounts();

        document.dispatchEvent(new CustomEvent("variants:filtered"));

        // Simulate clicks after all listeners are ready — triggers theme highlight + tag creation
        // isSyncing blocks applyFilters so URL params are not touched
        setTimeout(() => {
          isSyncing = true;

          document
            .querySelectorAll('#filter-color input[type="checkbox"]')
            .forEach((cb) => {
              const val = cb.value.toLowerCase();
              if (filterColors.includes(val)) {
                cb.disabled = false; // re-enable in case refreshCounts disabled it
                cb.click();
              }
            });
          document
            .querySelectorAll('#filter-size input[type="checkbox"]')
            .forEach((cb) => {
              const val = getSizeValue(cb);
              if (filterSizes.includes(val)) {
                cb.disabled = false;
                cb.click();
              }
            });
          document
            .querySelectorAll('#filter-producttype input[type="checkbox"]')
            .forEach((cb) => {
              const val = (
                cb.dataset.optionProducttype || cb.value
              ).toLowerCase();
              if (filterproducttypes.includes(val)) {
                cb.disabled = false;
                cb.click();
              }
            });
          document
            .querySelectorAll('#filter-lidtype input[type="checkbox"]')
            .forEach((cb) => {
              const val = (cb.dataset.optionLidtype || cb.value).toLowerCase();
              if (filterLidTypes.includes(val)) {
                cb.disabled = false;
                cb.click();
              }
            });

          isSyncing = false;
        }, 100);

        // Sync swatches and size on each visible card after theme re-renders
        setTimeout(() => {
          allCards = getAllCards();
          allCards.forEach((card) => {
            if (!isCardVisible(card)) return;
            syncCardSwatchesAndSize(card);
          });
          const visibleCount = allCards.filter(
            (card) => card.dataset.filtered === "false",
          ).length;
          const resultsEl = document.querySelector("#collection__filter__results");
          if (resultsEl) {
            resultsEl.innerText =
              visibleCount + (visibleCount === 1 ? " result" : " results");
          }
        }, 600);
      } else if (attempts < 20) {
        setTimeout(() => tryApplyInitialFilters(attempts + 1), 100);
      }
    }
    tryApplyInitialFilters(0);
  }

  // -----------------------------
  // FILTER LISTENER
  // -----------------------------

  document
    .getElementById("data-custom-filters")
    .addEventListener("change", function (event) {
      if (!event.target.matches('input[type="checkbox"]')) return;
      if (isSyncing) return;

      const device = getDeviceType();

      // Enable preview mode only on mobile
      isMobilePreviewMode = device === "Mobile";

      if (event.target.closest("#filter-size")) {
        applyFilters(event.target.value || null, null, null, null);
      } else if (event.target.closest("#filter-color")) {
        applyFilters(null, event.target.value || null, null, null);
      } else if (event.target.closest("#filter-producttype")) {
        applyFilters(null, null, event.target.value || null, null);
      } else if (event.target.closest("#filter-lidtype")) {
        applyFilters(null, null, null, event.target.value || null);
      }
    });

  function applyFilters(size, color, producttype, lidtype) {
    allCards = getAllCards();
    if (size !== null && size !== undefined && size !== "") {
      size = normalizeSizeFilterValue(size);
      if (filterSizes.includes(size)) {
        filterSizes = filterSizes.filter((s) => s !== size);
      } else {
        filterSizes.push(size);
      }
    }
    if (color !== null && color !== undefined && color !== "") {
      const normalizedColor = color.trim().toLowerCase();
      if (filterColors.includes(normalizedColor)) {
        filterColors = filterColors.filter((c) => c !== normalizedColor);
      } else {
        filterColors.push(normalizedColor);
      }
    }
    if (
      producttype !== null &&
      producttype !== undefined &&
      producttype !== ""
    ) {
      if (filterproducttypes.includes(producttype)) {
        filterproducttypes = filterproducttypes.filter(
          (pt) => pt !== producttype,
        );
      } else {
        filterproducttypes.push(producttype);
      }
    }
    if (lidtype !== null && lidtype !== undefined && lidtype !== "") {
      if (filterLidTypes.includes(lidtype)) {
        filterLidTypes = filterLidTypes.filter((lt) => lt !== lidtype);
      } else {
        filterLidTypes.push(lidtype);
      }
    }

    allCards.forEach((card) => {
      if (cardMatchesActiveFilters(card)) {
        card.dataset.filtered = "false";

        if (!isMobilePreviewMode) {
          card.style.display = "";
        }
      } else {
        card.dataset.filtered = "true";

        if (!isMobilePreviewMode) {
          card.style.display = "none";
        }
      }
    });

    const visibleCards = allCards.filter(
      (card) => card.dataset.filtered === "false",
    );

    document.querySelector("#collection__filter__results").innerText =
      visibleCards.length +
      (visibleCards.length === 1 ? " result" : " results");
    applyCurrentFilterCounts();

    updateURLFromFilters(
      filterColors,
      filterSizes,
      filterproducttypes,
      filterLidTypes,
    );

    // Only trigger pagination rerender on desktop — on mobile cards update after "View Results" click
    if (!isMobilePreviewMode) {
      document.dispatchEvent(new CustomEvent("variants:filtered"));
    }

    // Sync swatches and size on each visible card after theme re-renders
    setTimeout(() => {
      allCards = getAllCards();
      allCards.forEach((card) => {
        if (!isCardVisible(card)) return;
        syncCardSwatchesAndSize(card);
      });
    }, 600); // longer delay — waits for theme re-render to complete
  }
  function recomputeCountsFromVisibleCards(visibleCards) {
    const colorCounts = new Map();
    const sizeCounts = new Map();
    const productTypeCounts = new Map();
    const lidTypeCounts = new Map();

    visibleCards.forEach((card) => {
      const colors = (card.dataset.variantColor || "")
        .split(",")
        .map((c) => c.trim().toLowerCase())
        .filter(Boolean);

      const sizes = (card.dataset.variantSize || "")
        .split(",")
        .map((s) => normalizeSizeFilterValue(s))
        .filter(Boolean);
      const productTypes = (card.dataset.variantProducttype || "")
        .split(",")
        .map((pt) => pt.trim().toLowerCase())
        .filter(Boolean);
      const lidTypes = (card.dataset.variantLidtype || "")
        .split(",")
        .map((lt) => lt.trim().toLowerCase())
        .filter(Boolean);

      colors.forEach((c) => {
        colorCounts.set(c, (colorCounts.get(c) || 0) + 1);
      });

      sizes.forEach((s) => {
        sizeCounts.set(s, (sizeCounts.get(s) || 0) + 1);
      });
      productTypes.forEach((pt) => {
        productTypeCounts.set(pt, (productTypeCounts.get(pt) || 0) + 1);
      });
      lidTypes.forEach((lt) => {
        lidTypeCounts.set(lt, (lidTypeCounts.get(lt) || 0) + 1);
      });
    });

    return { colorCounts, sizeCounts, productTypeCounts, lidTypeCounts };
  }

  function updateURLFromFilters(colors, sizes, productTypes, lidTypes) {
    const url = new URL(window.location.href);
    url.searchParams.delete("page");

    // CHANGE: use custom param names Shopify won't intercept
    if (colors.length) {
      url.searchParams.set("cf_color", colors.join(","));
    } else {
      url.searchParams.delete("cf_color");
    }

    if (sizes.length) {
      url.searchParams.set("cf_size", sizes.join(","));
    } else {
      url.searchParams.delete("cf_size");
    }

    if (productTypes.length) {
      url.searchParams.set("cf_type", productTypes.join(","));
    } else {
      url.searchParams.delete("cf_type");
    }

    if (lidTypes.length) {
      url.searchParams.set("cf_lid", lidTypes.join(","));
    } else {
      url.searchParams.delete("cf_lid");
    }

    window.history.pushState({}, "", url);
  }
  // -----------------------------
  // MutationObserver
  // -----------------------------
  const observer = new MutationObserver((mutations) => {
    let found = false;

    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (
          node.nodeType === 1 &&
          (node.classList?.contains("product-card") ||
            node.querySelector?.(".product-card"))
        ) {
          found = true;
          break;
        }
      }
      if (found) break;
    }

    if (found) {
      // Don't interfere while sorting.js is swapping cards — filter:reapply handles it
      if (window.__sortSwapping) return;
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(() => {
        allCards = getAllCards();
        refreshCounts();
        allCards.forEach((card) => {
          if (!isCardVisible(card)) return;
          syncCardSwatchesAndSize(card);
        });
      }, 120);
    }
  });

  document.addEventListener("variants:filtered", () => {
    setTimeout(() => {
      allCards = getAllCards();
      allCards.forEach((card) => {
        if (!isCardVisible(card)) return;
        syncCardSwatchesAndSize(card);
      });
    }, 120);
  });

  // Re-apply active filter state after sorting.js swaps in new cards
  document.addEventListener("filter:reapply", () => {
    // After sorting.js swaps innerHTML, the new cards need time for the theme
    // to re-attach its own event listeners before we start clicking swatches.
    // We use a short delay for show/hide (no DOM interaction needed) and a
    // longer delay for swatch selection (needs theme listeners to be live).

    setTimeout(() => {
      allCards = getAllCards();
      if (!allCards.length) return;

      // Step 1: show/hide cards based on active filter state
      allCards.forEach((card) => {
        const visible = cardMatchesActiveFilters(card);
        card.dataset.filtered = visible ? "false" : "true";
        card.style.display = visible ? "" : "none";
      });

      // Step 2: update result count
      const visibleCount = allCards.filter(
        (c) => c.dataset.filtered === "false"
      ).length;
      const resultsEl = document.querySelector("#collection__filter__results");
      if (resultsEl) {
        resultsEl.innerText =
          visibleCount + (visibleCount === 1 ? " result" : " results");
      }

      // Step 3: sync swatches — extra delay so the theme's own listeners
      // on freshly swapped cards have fully re-attached before we click
      setTimeout(() => {
        allCards = getAllCards();
        allCards.forEach((card) => {
          if (!isCardVisible(card)) return;
          syncCardSwatchesAndSize(card);
        });

        // Step 4: refresh counts after swatches are selected
        refreshCounts(allCards);
        applyCurrentFilterCounts();

        document.dispatchEvent(new CustomEvent("variants:filtered"));
      }, 500);

    }, 100);
  });

  ["product_content"].forEach((id) => {
    const container = document.getElementById(id);
    if (container) {
      observer.observe(container, {
        childList: true,
        subtree: true,
      });
    }
  });

  (function () {
    const MOBILE_WIDTH = 768;

    function init() {
      const button = document.getElementById("view_result_mobile");
      if (!button) return;

      function updateVisibility() {
        if (window.innerWidth <= MOBILE_WIDTH) {
          button.style.display = "inline-block";
        } else {
          button.style.display = "none";
        }
      }

      // Run once
      updateVisibility();

      // Run on resize
      window.addEventListener("resize", updateVisibility);

      button.addEventListener("click", function (e) {
        e.preventDefault();

        isMobilePreviewMode = false;

        // Apply visual filtering
        allCards.forEach((card) => {
          if (card.dataset.filtered === "false") {
            card.style.display = "";
          } else {
            card.style.display = "none";
          }
        });

        // Now trigger pagination to rerender with filtered results
        document.dispatchEvent(new CustomEvent("variants:filtered"));

        document
          .getElementById("product_filter")
          .classList.remove("open-filter");

        // Optional smooth scroll to results
        const grid = document.getElementById("product_content");
        if (grid) {
          grid.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }
  })();

  $(".ui-accordion ul li > div:first-child").click(function () {
    const li = $(this).parent();
    const panel = $(this).next(".ui-accordion__panel");

    li.toggleClass("open");

    if (panel.is(":visible")) {
      panel.stop(true, true).slideUp();
    } else {
      panel.stop(true, true).slideDown(300, function () {
        $(this).css("display", "flex"); // keep flex after open
      });
    }
  });
  const buttonBox = document.getElementById("swaBox");
  const removeBtn = document.getElementById("removeAll");

  /* =========================================================
   HELPER → CREATE TAG
========================================================= */
  function createTag({ type, value, label, extraHtml = "" }) {
    const tagId = `tag-${type}-${value}`;

    if (document.getElementById(tagId)) return;

    buttonBox.insertAdjacentHTML(
      "beforeend",
      `
    <tag id="${tagId}" class="tagPill fade-in" data-type="${type}" data-value="${value}">
      ${extraHtml}
      <span style="margin-top:1px">${label}</span>
      <svg width="10" height="10" viewBox="0 0 15.5 15.5" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.8 7.8l6.5-6.5c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0L7.8 6.7 1.3.2C1-.1.5-.1.2.2s-.3.8 0 1.1l6.5 6.5-6.5 6.5c-.3.3-.3.8 0 1.1.1.1.3.2.5.2s.4-.1.5-.2l6.5-6.5 6.5 6.5c.1.1.3.2.5.2s.4-.1.5-.2c.3-.3.3-.8 0-1.1z"/>
      </svg>
    </tag>`,
    );
  }

  function removeTag(type, value) {
    document.getElementById(`tag-${type}-${value}`)?.remove();
  }

  /* =========================================================
   COLOR FILTER
========================================================= */
  document
    .getElementById("filter-color")
    .addEventListener("change", function (e) {
      const input = e.target;
      if (!input.matches('input[type="checkbox"]')) return;

      const li = input.closest("li");
      const label = li?.querySelector("[data-swatch-name]");
      if (!label) return;

      const displayValue = label.dataset.swatchName;
      const value = displayValue.toLowerCase();
      const color = input.dataset.swatchColor || "transparent";

      if (input.checked) {
        createTag({
          type: "color",
          value,
          label: `COLOR: ${displayValue}`,
          extraHtml: `
        <span class="colorBg" style="
          display:inline-block;
          width:12px;
          height:12px;
          border-radius:50%;
          border:1px solid #555;
          vertical-align:middle;
          background:${color};
          margin-top:-1px;
        "></span>
      `,
        });
      } else {
        removeTag("color", value);
      }
    });

  /* =========================================================
   SIZE FILTER
========================================================= */
  document
    .getElementById("filter-size")
    .addEventListener("change", function (e) {
      const input = e.target;
      if (!input.matches('input[type="checkbox"]')) return;

      const value = getSizeValue(input);
      if (!value) return;

      if (input.checked) {
        createTag({
          type: "size",
          value,
          label: `SIZE: ${value}`,
        });
      } else {
        removeTag("size", value);
      }
    });

  /* =========================================================
   LID TYPE FILTER
========================================================= */
  document
    .getElementById("filter-lidtype")
    .addEventListener("change", function (e) {
      const input = e.target;
      if (!input.matches('input[type="checkbox"]')) return;

      const value = input.dataset.optionLidtype;
      if (!value) return;

      if (input.checked) {
        createTag({
          type: "lidtype",
          value,
          label: `LID: ${value.toUpperCase()}`,
        });
      } else {
        removeTag("lidtype", value);
      }
    });

  /* =========================================================
   PRODUCT TYPE FILTER
========================================================= */
  document
    .getElementById("filter-producttype")
    .addEventListener("change", function (e) {
      const input = e.target;
      if (!input.matches('input[type="checkbox"]')) return;

      const value = input.dataset.optionProducttype;
      if (!value) return;

      if (input.checked) {
        createTag({
          type: "producttype",
          value,
          label: `TYPE: ${value.toUpperCase()}`,
        });
      } else {
        removeTag("producttype", value);
      }
    });

  /* =========================================================
   TAG ❌ CLICK (ALL TYPES)
========================================================= */
  buttonBox.addEventListener("click", function (e) {
    const svg = e.target.closest("svg");
    if (!svg) return;

    const tag = svg.closest(".tagPill");
    if (!tag) return;

    const { value, type } = tag.dataset;

    /* ===== COLOR ===== */
    if (type === "color") {
      // case-insensitive lookup for swatch name
      const label =
        document.querySelector(
          `#filter-color label[data-swatch-name="${value}"]`,
        ) ||
        [
          ...document.querySelectorAll("#filter-color label[data-swatch-name]"),
        ].find(
          (l) => l.dataset.swatchName.toLowerCase() === value.toLowerCase(),
        );
      if (label) {
        const inputId = label.getAttribute("for");
        document.getElementById(inputId)?.click();
      }
    }

    /* ===== SIZE ===== */
    if (type === "size") {
      const input = [...document.querySelectorAll("#filter-size input")].find(
        (sizeInput) => getSizeValue(sizeInput) === value,
      );
      if (input) {
        input.checked = false;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    /* ===== LID TYPE ===== */
    if (type === "lidtype") {
      const input = document.querySelector(
        `#filter-lidtype input[data-option-lidtype="${value}"]`,
      );
      if (input) {
        input.checked = false;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    /* ===== PRODUCT TYPE ===== */
    if (type === "producttype") {
      const input = document.querySelector(
        `#filter-producttype input[data-option-producttype="${value}"]`,
      );
      if (input) {
        input.checked = false;
        input.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }
  });

  /* =========================================================
   REMOVE ALL
========================================================= */
  removeBtn.addEventListener("click", function () {
    document
      .querySelectorAll(
        "#filter-color input:checked, #filter-size input:checked, #filter-lidtype input:checked, #filter-producttype input:checked",
      )
      .forEach((input) => input.click());
  });

  /* =========================================================
   TOGGLE REMOVE ALL BUTTON
========================================================= */
  function toggleRemoveAll() {
    removeBtn.style.display = buttonBox.querySelector(".tagPill")
      ? "block"
      : "none";
  }

  new MutationObserver(toggleRemoveAll).observe(buttonBox, {
    childList: true,
  });

  toggleRemoveAll();

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".pagination a");
    if (!btn) return;

    e.preventDefault(); // stop anchor jump

    // 👉 run your pagination / AJAX logic here

    requestAnimationFrame(() => {
      const target = document.querySelector(".main-filter-div");
      if (!target) return;

      const headerOffset = 120; // change if needed
      const y =
        target.getBoundingClientRect().top + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    });
  });
});
